import ACTIONS, { FETCH_STATUS } from "../constants";

export const getProjectsAttempt = {
  pending: {
    type: ACTIONS.PROJECTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROJECTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROJECTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProjects = (state) => ({
  type: ACTIONS.PROJECTS_CALL,
  payload: state,
});

export const createProjectAttempt = {
  pending: {
    type: ACTIONS.CREATE_PROJECT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_PROJECT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),

  error: (error) => ({
    type: ACTIONS.CREATE_PROJECT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createProjectRequest = (state) => ({
  type: ACTIONS.CREATE_PROJECT_CALL,
  payload: state,
});

// delete project
export const deleteProjectAttempt = {
  pending: {
    type: ACTIONS.DELETE_PROJECT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_PROJECT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),

  error: (error) => ({
    type: ACTIONS.DELETE_PROJECT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteProjectRequest = (state) => ({
  type: ACTIONS.DELETE_PROJECT_CALL,
  payload: state,
});
// Assigned Resources
export const getResourcesAttempt = {
  pending: {
    type: ACTIONS.GET_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),

  error: (error) => ({
    type: ACTIONS.GET_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getResourcesRequest = (state) => ({
  type: ACTIONS.GET_RESOURCES_CALL,
  payload: state,
});

// Program Managers

export const getProgramManagersAttempt = {
  pending: {
    type: ACTIONS.GET_PROGRAM_MANAGERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROGRAM_MANAGERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),

  error: (error) => ({
    type: ACTIONS.GET_PROGRAM_MANAGERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getProgramManagersRequest = (state) => ({
  type: ACTIONS.GET_PROGRAM_MANAGERS_CALL,
  payload: state,
});
// programs
export const getProgramsAttempt = {
  pending: {
    type: ACTIONS.GET_PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getPrograms = (state) => ({
  type: ACTIONS.GET_PROGRAMS_CALL,
  payload: state,
});

//
// project overview
// export const getProjectOverviewAttempt = {
//   pending: {
//     type: ACTIONS.GET_PROJECT_OVERVIEW.PENDING,
//     status: FETCH_STATUS.LOADING,
//   },
//   success: (data) => ({
//     type: ACTIONS.GET_PROJECT_OVERVIEW.SUCCESS,
//     data,
//     status: FETCH_STATUS.SUCCESS,
//   }),
//   error: (error) => ({
//     type: ACTIONS.GET_PROJECT_OVERVIEW.ERROR,
//     error,
//     status: FETCH_STATUS.ERROR,
//   }),
// };
// export const getProjectOverview = (state) => ({
//   type: ACTIONS.GET_PROJECT_OVERVIEW_CALL,
//   payload: state,
// });
export const getProjectDetailsAttempt = {
  pending: {
    type: ACTIONS.GET_PROJECT_DETAILS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROJECT_DETAILS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROJECT_DETAILS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProjectDetails = (state) => ({
  type: ACTIONS.GET_PROJECT_DETAILS_CALL,
  payload: state,
});

// project budget summary
export const getProjectBudgetSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PROJECT_BUDGET_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROJECT_BUDGET_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROJECT_BUDGET_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProjectBudgetSummary = (state) => ({
  type: ACTIONS.GET_PROJECT_BUDGET_SUMMARY_CALL,
  payload: state,
});
// project progress summary
export const getProjectProgressSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProjectProgressSummary = (state) => ({
  type: ACTIONS.GET_PROJECT_PROGRESS_SUMMARY_CALL,
  payload: state,
});

// update project request
export const updateProjectAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PROJECT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PROJECT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PROJECT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const updateProjectRequest = (state) => ({
  type: ACTIONS.UPDATE_PROJECT_CALL,
  payload: state,
});

export const updateProjectFlagAttempt = {
  pending: {
    type: ACTIONS.PROJECT_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROJECT_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROJECT_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateProjectFlag = (state) => ({
  type: ACTIONS.PROJECT_FLAG_CALL,
  payload: state,
});

/////////////////////////////////Allocated Resources///////////////////////
// export const getProjectResourcesAttempt = {
//   pending: {
//     type: ACTIONS.PROJECT_RESOURCES.PENDING,
//     status: FETCH_STATUS.LOADING,
//   },
//   success: (data) => (
//     {
//     type: ACTIONS.PROJECT_RESOURCES.SUCCESS,
//     data,
//     status: FETCH_STATUS.SUCCESS,
//   }),
//   error: (error) => ({
//     type: ACTIONS.PROJECT_RESOURCES.ERROR,
//     error,
//     status: FETCH_STATUS.ERROR,    
//   }),
// };
// export const getProjectResources = (state) => ({
//   type: ACTIONS.PROJECT_RESOURCES_CALL,
//   payload: state,
// });


// // create
// export const createProjectResourcesAttempt = {
//   pending: {
    // type: ACTIONS.CREATE_PROJECT_RESOURCES.PENDING,
//     status: FETCH_STATUS.LOADING,
//   },
//   success: (data) => ({
//     type: ACTIONS.CREATE_PROJECT_RESOURCES.SUCCESS,
//     data,
//     status: FETCH_STATUS.SUCCESS,
//   }),
//   error: (error) => ({
//     type: ACTIONS.CREATE_PROJECT_RESOURCES.ERROR,
//     error,
//     status: FETCH_STATUS.ERROR,    
//   }),
// };
// export const createProjectResourcesRequest = (state) => ({
//   type: ACTIONS.CREATE_PROJECT_RESOURCES_CALL,
//   payload: state,
// });

// // update
// export const updateProjectResourcesAttempt = {
//   pending: {
//     type: ACTIONS.UPDATE_PROJECT_RESOURCES.PENDING,
//     status: FETCH_STATUS.LOADING,
//   },
//   success: (data) => ({
//     type: ACTIONS.UPDATE_PROJECT_RESOURCES.SUCCESS,
//     data,
//     status: FETCH_STATUS.SUCCESS,
//   }),
//   error: (error) => ({
//     type: ACTIONS.UPDATE_PROJECT_RESOURCES.ERROR,
//     error,
//     status: FETCH_STATUS.ERROR,    
//   }),
// };
// export const updateProjectResourcesRequest = (state) => ({
//   type: ACTIONS.UPDATE_PROJECT_RESOURCES_CALL,
//   payload: state,
// });

// // delete
// export const deleteProjectResourcesAttempt = {
//   pending: {
//     type: ACTIONS.DELETE_PROJECT_RESOURCES.PENDING,
//     status: FETCH_STATUS.LOADING,
//   },
//   success: (data) => ({
//     type: ACTIONS.DELETE_PROJECT_RESOURCES.SUCCESS,
//     data,
//     status: FETCH_STATUS.SUCCESS,
//   }),
//   error: (error) => ({
//     type: ACTIONS.DELETE_PROJECT_RESOURCES.ERROR,
//     error,
//     status: FETCH_STATUS.ERROR,    
//   }),
// };
// export const deleteProjectResourcesRequest = (state) => ({
//   type: ACTIONS.DELETE_PROJECT_RESOURCES_CALL,
//   payload: state,
// });


// CREATE CHANGE REQUEST RISK

export const createRiskRequest = (state) => ({
  type: ACTIONS.CREATE_CHANGE_REQUEST_RISK_CALL,
  payload: state,
});

export const createRiskRequestAttempt = {
  pending: {
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_CHANGE_REQUEST_RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

//////////// STATUS REPORT //////////////////

export const filterHealthStatusAttempt = {
  pending: {
    type: ACTIONS.HEALTH_STATUS_FILTER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.HEALTH_STATUS_FILTER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.HEALTH_STATUS_FILTER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const filterHealthStatus = (state) => ({
  type: ACTIONS.HEALTH_STATUS_FILTER_CALL,
  payload: state,
});

export const StatusReportRequestAttempt = {
  pending: {
    type: ACTIONS.STATUS_REPORT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.STATUS_REPORT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.STATUS_REPORT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const StatusReportRequest = (state) => ({
  type: ACTIONS.STATUS_REPORT_CALL,
  payload: state,
});

export const clearReportRequest = () => ({
  type: ACTIONS.CLEAR_STATUS_REPORT,
});

export const ConfirmWsrReportAttempt = {
  pending: {
    type: ACTIONS.CONFIRM_WSR_REPORT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CONFIRM_WSR_REPORT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CONFIRM_WSR_REPORT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const ConfirmWsrReport = (state) => ({
  type: ACTIONS.CONFIRM_WSR_REPORT_CALL,
  payload: state,
});






//-----------------------------------PROJECT REsources-----------------------------------

// GET Resourcses

export const getProjectResourcesRequest = (state) => ({
  type: ACTIONS.PROJECT_RESOURCES_CALL,
  payload: state,
});

export const getProjectResourcesAttempt = {
  pending: {
    type: ACTIONS.PROJECT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROJECT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROJECT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortProjectResourcesAttempt = {
  pending: {
    type: ACTIONS.SORT_PROJECT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_PROJECT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_PROJECT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortProjectResourcesRequest = (state) => ({
  type: ACTIONS.SORT_PROJECT_RESOURCES_CALL,
  payload: state,
});

// CREATE PROJECT RESOURCES

export const createProjectResourcesRequest = (state) => ({
  type: ACTIONS.CREATE_PROJECT_RESOURCES_CALL,
  payload: state,
});

export const createProjectResourcesAttempt = {
  pending: {
    type: ACTIONS.CREATE_PROJECT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_PROJECT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_PROJECT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE PROJECT RESOURCES

export const updateProjectResourcesRequest = (state) => ({
  type: ACTIONS.UPDATE_PROJECT_RESOURCES_CALL,
  payload: state,
});

export const updateProjectResourcesAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PROJECT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PROJECT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PROJECT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE Project Resources

export const deleteProjectResourceRequest = (state) => ({
  type: ACTIONS.DELETE_PROJECT_RESOURCE_CALL,
  payload: state,
});

export const deleteProjectResourceAttempt = {
  pending: {
    type: ACTIONS.DELETE_PROJECT_RESOURCE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_PROJECT_RESOURCE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_PROJECT_RESOURCE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

//----------------------------------- HEALTH STATUS -----------------------------------

// GET METRIX

export const getMetrics = (state) => ({
  type: ACTIONS.METRIX_CALL,
  payload: state,
});

export const getMetricsAttempt = {
  pending: {
    type: ACTIONS.METRIX.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.METRIX.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.METRIX.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE METRIX

export const updateStatusKPI = (state) => ({
  type: ACTIONS.UPDATE_KPI_CALL,
  payload: state,
});

export const updateStatusKPIAttempt = {
  pending: {
    type: ACTIONS.UPDATE_KPI.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_KPI.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_KPI.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortProjectRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_PROJECTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_PROJECTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_PROJECTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortProjectRequest = (state) => ({
  type: ACTIONS.SORT_PROJECTS_CALL,
  payload: state,
});